import { apolloClient } from 'apollo-client';
import { SET_PAYMENT_METHOD_ON_PLANS } from '../../../../payment-methods.api';

export const setPaymentMethodOnPlans = async (
  context: AddPaymentMethodContext
) => {
  const { mutationVariablesForSetPayment, isActivePlanWhale } = context;
  if (!mutationVariablesForSetPayment) return { updatedPlans: undefined };

  const { data } = await apolloClient.mutate<
    SetPaymentMethodOnPlansMutation,
    SetPaymentMethodOnPlansMutationVariables
  >({
    mutation: SET_PAYMENT_METHOD_ON_PLANS,
    variables: {
      ...mutationVariablesForSetPayment,
      skipDisplayName: !!isActivePlanWhale,
    },
  });

  return { updatedPlans: data?.setPaymentMethodOnPlans?.updatedPlans };
};
